
/*
 * 文件EN: clientClue.js,
 * 文件CN: 商户激活查询列表
 * 创建人: huli
 */
import request from '@/plugins/http'

/**
 * @desc 客户线索查询列表
 * @method GET
 * @param {}
 */
export const getListData = params => {
  return request.get('/customer/leads/list', params)
}

/**
 * @desc 客户线索详情
 * @method GET
 * @param {}
 */
export const getDetail = params => {
  return request.get('/customer/leads/detail', params)
}


/**
 * @desc 客户线索转化按钮
 * @method GET
 * @param {}
 */
export const changeMer = params => {
  return request.get('/customer/leads/change', params)
}

/**
 * @desc 客户线索新增跟进日志
 * @method GET
 * @param {}
 */
export const recordMer = params => {
  return request.get('/customer/leads/record', params)
}